import React, { Component } from 'react';
import VersionDetails from './VersionDetails';
import VersionFiles from './VersionFiles';

class VersionsTable extends Component {
    render() {
        return (
            <table>
                <thead>
                <tr>
                    <th className='version-number'>Version</th>
                    <th className='version-date'>Date</th>
                    <th className='downloads'>Files</th>
                    <th className='version-details'>Details</th>
                </tr>
                </thead>
                <tbody>
                {this.props.versions.map((ver) =>
                    <tr key={ver.id}>
                        <td>{ver.number}</td>
                        <td>{new Date(ver.date).toLocaleDateString()}</td>
                        <VersionFiles files={ver.files} />
                        <VersionDetails details={ver.details} />
                    </tr>)}
                </tbody>
            </table>);
    }
}

export default VersionsTable;